module.exports = "textarea {\n  min-height: 224px; }\n\n.ui-g-12 {\n  padding: 0px; }\n"